import styled from "styled-components";

export const StepsRowStyled = styled.div`
  display: flex;
  gap: 8px;
  padding: 0 24px 16px;
`;

export const StepPillStyled = styled.div`
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 11.5px;
  font-weight: 600;
  background: ${(p) => (p.$active ? p.theme?.colors?.primary ?? "#008080" : p.theme?.colors?.light ?? "#F0F2F5")};
  color: ${(p) => (p.$active ? "#fff" : p.theme?.colors?.textSecondary ?? "#5A6A7A")};
`;

export const GroupHeadingStyled = styled.div`
  padding: 10px 24px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: ${(p) => p.theme?.colors?.textSecondary ?? "#5A6A7A"};
  background: ${(p) => p.theme?.colors?.light ?? "#F7F7F7"};
`;

export const SummaryRowStyled = styled.div`
  padding: 8px 0;
  border-bottom: 1px solid ${(p) => p.theme?.colors?.borderLight ?? "#EEF1F5"};
`;
